import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SignUpComponent } from './sign-up/sign-up.component';
import { MatButtonModule } from '@angular/material/button';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

const COMPONENTS = [
  AuthComponent, SignInComponent,
  SignUpComponent, ForgotPasswordComponent
];

export const auth_nav_path = {
  signIn: '/auth/sign-in',
  signUp: '/auth/sign-up',
  forgotPassword: '/auth/forgot-password'
};

const routes: Routes = [
  { path: '', component: AuthComponent, children: [
      { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'sign-in', component: SignInComponent },
      { path: 'sign-up', component: SignUpComponent }
    ] }
];

const ANGULAR_MATERIAL_MODULES = [
  MatButtonModule, MatFormFieldModule, MatInputModule
];

const CORE_MODULES = [
  CommonModule, ReactiveFormsModule
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [RouterModule.forChild(routes), ...CORE_MODULES, ...ANGULAR_MATERIAL_MODULES],
  exports: [RouterModule]
})
export class AuthModule { }
